import {Injectable} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {VenueCompany} from "./venue-company.data";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class VenueCompanyService {
    constructor(private auth: AuthApiService, private http: HttpClient) {
    }


    async getVenueCompany(venueId: string): Promise<VenueCompany> {
        return firstValueFrom(this.http.get<VenueCompany>("/fonzie/customer-instance-venue/" + venueId + "/venue-company", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async createVenueCompany(venueId: string, company: VenueCompany): Promise<VenueCompany> {
        return firstValueFrom(this.http.post<VenueCompany>("/fonzie/customer-instance-venue/" + venueId + "/venue-company", company, {headers: this.auth.getHttpHeaderOptions()}));
    }

}
